import { Link } from "react-router-dom";

/**
 * Slack Integration Monitoring Page
 * - Shows status and recent activity of Slack integration
 * - Modern, clean, centered layout
 * - Uses .card, .badge, .grid, .grid-2 classes for consistency
 */

const mockEvents = [
  { time: "09:15", event: "Message sent to #compliance-alerts", status: "success" },
  { time: "09:10", event: "Slack bot connected", status: "success" },
  { time: "08:55", event: "Failed to post to #general", status: "error" },
  { time: "08:30", event: "Message sent to #security-updates", status: "success" },
];

export default function SlackMonitoring() {
  return (
    <div className="main-content" style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "32px 0" }}>
      <section className="card" style={{ maxWidth: 600, width: "100%", margin: "0 auto", padding: 32 }}>
        <div className="badge" style={{ marginBottom: 12 }}>Slack Integration</div>
        <h1 style={{ margin: "8px 0 16px 0" }}>Slack Monitoring</h1>
        <p style={{ color: "#4b5563", fontSize: 16, marginBottom: 24 }}>
          View the status and recent activity of your Slack integration.
        </p>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {mockEvents.map((e, i) => (
            <li key={i} style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
              <span style={{ width: 70, color: "#6a1b9a", fontWeight: 600 }}>{e.time}</span>
              <span style={{ flex: 1 }}>{e.event}</span>
              <span style={{ color: e.status === "success" ? "#059669" : "#dc2626", fontWeight: 600, marginLeft: 12 }}>
                {e.status === "success" ? "Success" : "Error"}
              </span>
            </li>
          ))}
        </ul>
        
      </section>
    </div>
  );
}
